import moment from "moment";
import dayjs from "dayjs";
import { isString } from "./StringService";

export function getCurrentDate() {
  const m = moment();

  const str = m.format("YYYY-MM-DD HH:mm:ss");
  return new Date(str);
}

/** returns string yyyy-mm-dd */
export function getToday() {
  return dayjs().format("YYYY-MM-DD");
}

/**
 * returns current day (if monday), or the previous monday
 */
export function getMonday() {
  if (isMonday(moment())) {
    return getYYYYMMDD();
  }
  return moment().startOf("isoWeek").format("YYYY-MM-DD");
}

export function getYYYYMMDD(date = null) {
  if (date == null) {
    date = moment();
  }
  if (isString(date)) {
    date = moment(date);
  }

  return date.format("YYYY-MM-DD");
}

export function getYYYYMMDD__JsDate(date) {
  return date.toISOString().split("T")[0];
}

export function convertToYYYYMMDD(dateStr) {
  const oDate = dayjs(dateStr);
  return oDate.format("YYYY-MM-DD");
}

export function getMD(mDate = null) {
  if (mDate == null) {
    mDate = moment();
  }
  return mDate.format("M/D");
}

export function getMMDD(date = null) {
  if (date == null) {
    date = moment();
  }
  if (isString(date)) {
    date = moment(date);
  }
  return date.format("MM/DD");
}

// 1-12
export function getMonthNum(mDate = null) {
  if (mDate == null) {
    mDate = moment();
  }
  return parseInt(mDate.format("M"));
}

export function getShortDay(mDate = null) {
  if (mDate == null) {
    mDate = moment();
  }
  return mDate.format("ddd");
}

export function getDay(mDate = null) {
  if (mDate == null) {
    mDate = moment();
  }
  return mDate.format("dddd");
}

export function getHour(mDate) {
  return parseInt(mDate.format("H"));
}

export function isWeekend(mDate) {
  const weekday = mDate.format("dddd"); // Monday ... Sunday
  return weekday === "Sunday" || weekday === "Saturday";
}

export function isMonThruThur(mDate) {
  const weekday = mDate.format("dddd"); // Monday ... Sunday
  return (
    weekday === "Monday" ||
    weekday === "Tuesday" ||
    weekday === "Wednesday" ||
    weekday === "Thursday"
  );
}

export function isFriday(mDate) {
  const weekday = mDate.format("dddd"); // Monday ... Sunday
  return weekday === "Friday";
}

export function isSunday(mDate) {
  const weekday = mDate.format("dddd"); // Monday ... Sunday
  return weekday === "Sunday";
}

export function getDayName(dateStr = null) {
  let mDate = null;
  if (dateStr == null) {
    mDate = moment();
  } else {
    mDate = moment(dateStr);
  }
  return mDate.format("dddd");
}

export function parseYYYYMMDD(dateStr) {
  return moment(dateStr);
}

function copyDate(mDate) {
  return mDate.clone();
}

export function addDays(mDate = null, dayCount) {
  if (mDate == null) {
    mDate = moment();
  }

  const mNewDate = copyDate(mDate);
  return mNewDate.add(dayCount, "d");
}

export function isMonday(mDate) {
  const weekday = mDate.format("dddd"); // Monday ... Sunday
  return weekday === "Monday";
}

export function subDays(mDate = null, dayCount) {
  if (mDate == null) {
    mDate = moment();
  }

  const mNewDate = copyDate(mDate);
  return mNewDate.subtract(dayCount, "d");
}

export function subDayStr(mDate = null, dayCount) {
  if (mDate == null) {
    mDate = moment();
  }

  const mNewDate = copyDate(mDate);
  return getYYYYMMDD(mNewDate.subtract(dayCount, "d"));
}

export function addDaysStr(dateStr, dayCount) {
  const mNewDate = moment(dateStr);
  return getYYYYMMDD(mNewDate.add(dayCount, "d"));
}

export function getTomorrow() {
  let mCurrentDate = moment().add(1, "d");
  return getYYYYMMDD(mCurrentDate);
}

export function isSameDate(mDate1, mDate2) {
  return mDate1.isSame(mDate2, "day");
}

export function getDifferenceInDays(mDate1, mDate2) {
  return mDate1.diff(mDate2, "days");
}

export function getThisWeeksMonday() {
  const mDate = moment().startOf("week").add(1, "day");
  return getYYYYMMDD(mDate);
}

export function getThisWeeksFriday() {
  const mDate = moment().startOf("week").add(5, "day");
  return getYYYYMMDD(mDate);
}

export function getThisWeeksSunday() {
  const mDate = moment().startOf("week");
  return getYYYYMMDD(mDate);
}

export function getThisWeeksSaturday() {
  const mDate = moment().endOf("week");
  return getYYYYMMDD(mDate);
}

export function diffInDaysFiltered(startDate, endDate, acceptFn) {
  let count = 0;
  let current = new Date(startDate);

  while (current <= endDate) {
    if (acceptFn(current)) {
      count++;
    }
    current.setDate(current.getDate() + 1); // move to next day
  }

  return count;
}

export function countWeekdays(startDate, endDate) {
  let count = 0;
  let current = dayjs(startDate);
  const end = dayjs(endDate);

  while (current.isBefore(end) || current.isSame(end, "day")) {
    const day = current.day();
    // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) {
      count++;
    }
    current = current.add(1, "day");
  }

  return count;
}

/**
 * Get all dates between two dates (inclusive), excluding weekends
 * @param {string|Date|dayjs.Dayjs} start
 * @param {string|Date|dayjs.Dayjs} end
 * @returns {string[]} array of dates in YYYY-MM-DD format
 */
export const getBusinessDatesBetween = (start, end) => {
  const dates = [];

  let current = dayjs(start).startOf("day");
  const last = dayjs(end).startOf("day");

  while (current.isBefore(last, "day") || current.isSame(last, "day")) {
    const day = current.day(); // 0 = Sun, 6 = Sat

    if (day !== 0 && day !== 6) {
      dates.push(current);
    }

    current = current.add(1, "day");
  }

  return dates;
};

export function getDayJsDay(date = null) {
  if (date == null) {
    date = dayjs();
  }
  if (isString(date)) {
    date = dayjs(date);
  }
  return date.format("dddd");
}

export function getDayJsMD(date = null) {
  if (date == null) {
    date = dayjs();
  }
  if (isString(date)) {
    date = dayjs(date);
  }
  return date.format("M/D");
}
